<template>
  <div class="h5-carts-header">
    Carts
    <p class="h5-carts-header__count">
      {{ cartStore.cartCount > 100 ? '99+' : cartStore.cartCount }}
    </p>
    <Icon
      v-if="selectedSkuCount > 0"
      class="h5-carts-header__delete"
      name="delete-trash"
      @click="handleCheckedDelete"
    />

    <div class="h5-carts-header__right">
      <div
        class="h5-carts-header__address"
        @click="handleAddressClick"
      >
        <Icon
          class="h5-carts-header__location"
          name="location-l"
        />
        <img
          class="h5-carts-header__country"
          :src="countryUrl"
        >
        <p
          class="h5-carts-header__city"
          v-if="addressStore.cacheAddress"
        >
          {{ addressStore.cacheAddress.city }}
        </p>
        <p
          class="h5-carts-header__add"
          v-else
        >
          Add New Address
        </p>
      </div>
      <Icon
        class="h5-carts-header__close"
        name="close-f-2"
        @click="$router.back()"
      />
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { useAddressStore } from '@/pinia/address'
import { useCartStore } from '@/pinia/cart'
import { useCart } from '@/views/Carts/hooks/useCart'
import { useAddress } from '../hooks/useAddress'
import { buriedPointUtil } from '@/utils/utils'
import { useShipStore } from '@/pinia/ship'
import { useOrder } from '../../hooks/useOrder'

const addressStore = useAddressStore()

const ship = useShipStore()

const countryUrl = computed(() => addressStore.cacheAddress ? addressStore.cacheAddress.searchImg : ship.country.countryUrl)

const { showAddressDialog } = useAddress()

const cartStore = useCartStore()

const { handleCheckedDelete } = useCart()
const { selectedSkuCount } = useOrder()

const handleAddressClick = () => {
  buriedPointUtil({ eventId: 'HCL201' })
  showAddressDialog.value = true
}
</script>

<style lang="less" scoped>
.h5-carts-header {
  display: flex;
  align-items: center;
  padding: 12px;
  height: 48px;
  border-radius: 8px;
  font-family: mon-700;
  font-size: 14px;
  line-height: 18px;
  background-color: #FFFFFF;

  &__count {
    margin-left: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3px 6px;
    color: #FFFFFF;
    background-color: #009DE0;
    border-radius: 10px;
    font-family: mon-500;
    font-size: 10px;
    line-height: 14px;
  }

  &__delete {
    margin-left: 12px;
    font-size: 20px;
  }

  &__right {
    margin-left: auto;
    display: flex;
  }

  &__address {
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  &__location {
    font-size: 20px;
  }

  &__country {
    margin-left: 4px;
    width: 18px;
  }

  &__city {
    margin-left: 4px;
    font-family: mon-600;
    font-size: 12px;
    line-height: 16px;
  }

  &__add {
    margin-left: 4px;
    font-family: mon-500;
    font-size: 11px;
    line-height: 14px;
    text-decoration: underline;
    color: #007EB3;
  }

  &__close {
    margin-left: 12px;
    font-size: 24px;
  }
}
</style>
